const INTERACTION_TYPES = {

}

module.exports = {
  INTERACTION_TYPES
}
